// The public Shopify App Store listing for Maya Insights.
//
// Installing from here is the ONLY entry point that produces the two things every
// Shopify-billed purchase needs: the shop domain and an OAuth grant for that shop.
// Shopify's return leg lands on `application_url` (shopify/shopify.app.toml →
// https://app.mayainsights.com/shopify-integration?shop=…), which resumes org selection,
// account linking and plan choice.
//
// So any "connect Shopify" affordance that has no ?shop= context must point HERE, never at
// /billing/products — a plan click there has no store to charge and dead-ends on the
// "Shop details required" modal. Mirrored backend-side as
// mayainsights.shopify_billing.APP_STORE_LISTING_URL; keep the two in sync.
export const SHOPIFY_APP_STORE_URL = 'https://apps.shopify.com/mayainsights'
